// 카카오 SDK 초기화 및 설정
export const initializeKakaoSDK = () => {
  // console.log('Initializing Kakao SDK...', window.Kakao && !window.Kakao.isInitialized());
  if (window.Kakao && typeof window.Kakao.isInitialized === 'function' && !window.Kakao.isInitialized()) {
    // 실제 사용 시 카카오 개발자 센터에서 발급받은 JavaScript 키를 사용하세요
    const KAKAO_APP_KEY = process.env.REACT_APP_KAKAOMAP_APPKEY || 'YOUR_KAKAO_APP_KEY';

    // console.log(KAKAO_APP_KEY);
    try {
      window.Kakao.init(KAKAO_APP_KEY);
      console.log('카카오 SDK 초기화 성공:', window.Kakao.isInitialized());
    } catch (error) {
      console.error('카카오 SDK 초기화 실패:', error);
    }
  } else {
    console.warn('Kakao SDK가 이미 초기화되었거나 isInitialized 함수가 없습니다.', window.Kakao);
  }
};

// 앱 초기화 시 호출
if (typeof window !== 'undefined' && window.Kakao) {
  initializeKakaoSDK();
}
